import React from "react";
import { Input, Badge } from '@scuf/common';

export default class InputNumber extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fileError: "",
            value: "",
            acceptedFiles: [],
            rejectedFiles: []
        };
    }

    handleOnChange = (dato) => {
        this.setState({ value: dato.val });
        this.props.onDato(dato);

        // if (!isNaN(dato.val)) {
        //     this.setState({ value: dato.val });
        //     this.props.onDato(dato);
        // }
        // else {
        //     this.props.onRemoveDato(dato);
        // }

        // if (dato.val === "") {
        //     this.props.onRemoveDato(dato);
        // }
    }

    handleValue(a, b) {
        return a === b
    }


    componentWillMount() {
        var nvalue = ""
        this.props.items.map((item) =>
            nvalue = item.value
        )
        this.setState({ value: nvalue });
    }

    render() {

        var idGrupo = this.props.idGrupo
        return (

            <React.Fragment>

                {this.props.items.map((item) => (
                    <React.Fragment>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Badge color={this.state.value === "" ? "red" : "green"} empty={true} />
                        {item.label}
                        <Input
                            type={"text"}
                            key={item.id}
                            fluid={true}
                            value={this.state.value}
                            onChange={(value) => this.handleOnChange({ key: idGrupo, id: item.id, val: value })}
                        //min={0}
                        />
                    </React.Fragment>
                ))}


            </React.Fragment>
        );
    }
}
